/**
 * propertyConditionAtOrigination
 */
export const selectOptionsPropertyConditionAtOrigination = [
  "C1",
  "C2",
  "C3",
  "C4",
  "C5",
  "C6",
  "TBD",
];
